import React, { useCallback, useEffect, useState } from "react";

import api from "../../util/panelApi";
import { PageHead, Tiles, fmt } from "./kit";

const cell = { padding: "6px 8px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13 };
const small = { fontSize: 12, color: "#6B7280" };

/// Aylik kart: coin ile alinir, sure boyunca her gun coin verir.
const MonthlyCard = () => {
  const [cfg, setCfg] = useState(null);
  const [sum, setSum] = useState([]);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const [r, s] = await Promise.all([api.config(), api.cardSummary()]);
    if (r?.status) {
      setCfg({
        monthlyCardEnabled: r.config.monthlyCardEnabled !== false,
        monthlyCards: r.config.monthlyCards || [],
      });
    }
    if (s?.status) setSum(s.data || []);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const save = async () => {
    for (const c of cfg.monthlyCards) {
      if (!c.key || !c.name) return window.alert("Her kartın anahtarı ve adı olmalı.");
      // ekonomi kontrolu: verilen coin fiyati gecerse sistem coin uretir
      const gives = (Number(c.instantCoin) || 0) + (Number(c.dailyCoin) || 0) * (Number(c.days) || 30);
      if (gives > (Number(c.price) || 0)) {
        if (!window.confirm(`"${c.name}" kartı ${fmt(gives)} coin veriyor ama ${fmt(c.price)} coine satılıyor. Bu zarar demek. Yine de kaydedilsin mi?`)) return;
      }
    }
    setSaving(true);
    const r = await api.saveConfig(cfg);
    setSaving(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    load();
  };

  const set = (i, k, v) =>
    setCfg({ ...cfg, monthlyCards: cfg.monthlyCards.map((c, j) => (i === j ? { ...c, [k]: v } : c)) });
  const setPerks = (i, text) => set(i, "perks", text.split("\n").filter((x) => x.trim()));
  const add = () =>
    setCfg({
      ...cfg,
      monthlyCards: [
        ...cfg.monthlyCards,
        { key: `c_${Date.now().toString(36)}`, name: "", price: 30000, days: 30, instantCoin: 0, dailyCoin: 1000, perks: [], enabled: true },
      ],
    });
  const del = (i) => setCfg({ ...cfg, monthlyCards: cfg.monthlyCards.filter((_, j) => j !== i) });

  if (!cfg) return <div className="badu-empty">Yükleniyor…</div>;

  return (
    <>
      <PageHead
        title="Aylık Kart"
        sub="Kullanıcı bir kez coin öder, süre boyunca her gün coin alır. Apple aboneliği değildir; Android'de de çalışır."
      />

      <Tiles
        items={[
          { label: "Durum", value: cfg.monthlyCardEnabled ? "Açık" : "Kapalı" },
          { label: "Aktif kart", value: fmt(sum.reduce((a, s) => a + s.active, 0)) },
          { label: "Toplanan coin", value: fmt(sum.reduce((a, s) => a + s.paid, 0)) },
          { label: "Dağıtılan coin", value: fmt(sum.reduce((a, s) => a + s.given, 0)) },
        ]}
      />

      <div className="card">
        <div className="card-body">
          <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
            <input
              type="checkbox"
              checked={cfg.monthlyCardEnabled}
              onChange={(e) => setCfg({ ...cfg, monthlyCardEnabled: e.target.checked })}
            />
            <b>Aylık kart açık</b>
          </label>

          {cfg.monthlyCards.map((c, i) => {
            const gives = (Number(c.instantCoin) || 0) + (Number(c.dailyCoin) || 0) * (Number(c.days) || 30);
            const profit = (Number(c.price) || 0) - gives;
            return (
              <div key={i} style={{ border: "1px solid #E5E7EB", borderRadius: 10, padding: 14, marginBottom: 12 }}>
                <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 10 }}>
                  <input type="checkbox" checked={c.enabled !== false} onChange={(e) => set(i, "enabled", e.target.checked)} />
                  <input style={{ ...cell, width: 220 }} value={c.name || ""} placeholder="Kart adı" onChange={(e) => set(i, "name", e.target.value)} />
                  <span style={small}>{c.key}</span>
                  <div className="ms-auto">
                    <button className="btn btn-sm btn-outline-danger" onClick={() => del(i)}>
                      Sil
                    </button>
                  </div>
                </div>

                <div className="d-flex" style={{ gap: 12, flexWrap: "wrap", marginBottom: 10 }}>
                  {[
                    ["price", "Fiyat (coin)"],
                    ["days", "Süre (gün)"],
                    ["instantCoin", "Anında coin"],
                    ["dailyCoin", "Günlük coin"],
                  ].map(([k, label]) => (
                    <div key={k}>
                      <div style={small}>{label}</div>
                      <input style={{ ...cell, width: 130 }} type="number" value={c[k] || 0} onChange={(e) => set(i, k, Number(e.target.value))} />
                    </div>
                  ))}
                </div>

                <div style={small}>Avantajlar (her satır bir madde)</div>
                <textarea
                  style={{ ...cell, width: "100%", minHeight: 70 }}
                  value={(c.perks || []).join("\n")}
                  onChange={(e) => setPerks(i, e.target.value)}
                />

                <div style={{ ...small, marginTop: 8, color: profit >= 0 ? "#059669" : "#DC2626" }}>
                  Toplam verilen: {fmt(gives)} coin · Kâr: {fmt(profit)} coin
                </div>
              </div>
            );
          })}

          <div className="d-flex" style={{ gap: 8 }}>
            <button className="btn btn-outline-secondary btn-sm" onClick={add}>
              Kart ekle
            </button>
            <button className="btn btn-primary btn-sm" disabled={saving} onClick={save}>
              {saving ? "Kaydediliyor…" : "Kaydet"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MonthlyCard;
